<template>
  <el-dialog width="1000px"
             custom-class="channel-dialog__wrap"
             title="选择渠道"
             :visible="visible"
             :close-on-click-modal="false"
             @open="handleOpen"
             @close="handleClose"
             :append-to-body="isAppendToBody"
             :modal-append-to-body="modelIsAppendToBody">
    <div class="popups-inner__body">
      <div class="popups-from__wrap">
        <el-form :size="formSize"
                 inline
                 :model="channelQuery">
          <el-form-item>
            <el-select clearable
                       v-model="channelQuery.businessType"
                       placeholder="请选择设备类型">
              <el-option v-for="item in deviceTypes"
                         :key="item.dictKey"
                         :label="item.dictValue"
                         :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select clearable
                       v-model="channelQuery.platformType"
                       placeholder="请选择平台类型">
              <el-option v-for="item in platformTypes"
                         :key="item.dictKey"
                         :label="item.dictValue"
                         :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input clearable
                      v-model="channelQuery.name"
                      placeholder="渠道名称/APPID"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="channelListLoading"
                       icon="el-icon-search"
                       type="primary"
                       @click="handleSearch">搜索</el-button>
           <el-button :loading="channelListLoading"
                         type="primary"
                         @click="forceUpdate">强制刷新</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="channel-table"
           v-loading="channelListLoading"
           element-loading-text="拼命加载中"
           element-loading-spinner="el-icon-loading">
        <lazyTable ref="lazyTable" :data="list"
                   v-if="visibleLazyTable">
          <el-table-column v-if="multiple"
                           label="测试"
                           width="50px">
            <template slot="header"
                      slot-scope="scope">
              <el-checkbox v-model="checked"
                           :indeterminate="indeterminate"
                           @change="handleSelectAll">{{
                " " }}</el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox :value="scope.row.checked"
                           @change="(checked) => handleSelectChange(scope.row, checked)">{{
                " " }}</el-checkbox>
            </template>
          </el-table-column>
          <el-table-column v-if="!multiple"
                           width="50px">
            <!-- 扩展渠道支持单选 -->
            <template slot-scope="scope">
              <el-radio v-model="scope.row.checked"
                        @input="handleSingleSelectChange(scope.row)">{{
                " " }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="APPID"
                           width="120"
                           prop="id"></el-table-column>
          <el-table-column label="渠道名称"
                           prop="name"></el-table-column>
          <el-table-column label="设备类型"
                           prop="terminalTypeName"
                           width="150"></el-table-column>
          <el-table-column label="平台类型"
                           prop="platformTypeName"
                           width="150"></el-table-column>
        </lazyTable>
        <div v-else><i class="el-icon-loading"></i></div>
        <!-- <virtual-table :data="list"></virtual-table> -->
      </div>
    </div>
    <div slot="footer"
         class="dialog-footer">
      <el-row :gutter="20">
        <el-col v-if="multiple"
                :span="6">
          <div class="select"
               style="text-align: left;">
            <el-popover placement="top-start"
                        v-model="showPreview"
                        width="600"
                        trigger="click">
              <div class="popover-title"
                   style="position: relative;">
                <span class="title">已选记录列表</span>
                <i class="el-icon-close"
                   style="position: absolute; right: 10px; top: 5px; cursor: pointer;"
                   @click="showPreview = false"></i>
              </div>
              <div class="popover-header"
                   style="position: relative">
                <span class="desc">已选择（<i>{{ selectedNum }}</i>）</span>
                <el-button type="text"
                           size="mini"
                           @click="handleClear">全部移除</el-button>
              </div>
              <div class="preview-table-container">
                <lb-table :data="selectedChannels"
                          :height="300"
                          :keeps="9999">
                  <lb-table-column label="APPID"
                                   width="120"
                                   prop="id"></lb-table-column>
                  <lb-table-column label="应用名称"
                                   prop="name"></lb-table-column>
                  <lb-table-column label="操作"
                                   prop="platformTypeName"
                                   width="150">
                    <template slot-scope="scope">
                      <el-button type="text"
                                 size="mini"
                                 @click="handleDelSelection(scope.row)">移除</el-button>
                    </template>
                  </lb-table-column>
                </lb-table>
              </div>
              <div class="reference"
                   slot="reference"
                   style="cursor: pointer; display: inline-block;">
                已选择（<el-button type="text"
                           :size="formSize">{{ selectedNum }}</el-button>）
              </div>
            </el-popover>

          </div>
        </el-col>
          <div style="display: flex;justify-content: flex-end;margin-right: 70px;">
            <el-button :size="formSize"
                       @click="handleCancel">取消</el-button>
            <el-button :size="formSize"
                       type="primary"
                       @click="handleSave">保存</el-button>
          </div>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
// import { getChannelList } from '@/api/sdk-universal-config/setting';
import {
  getChannelsResource
} from '@/api/resource/rabbittactics';
import {
  getChannels
} from '@/api/runActivityManage/activity';
import lazyTable from '@/components/lazyTable/index.vue';
import LbTable from '@/components/table';
import LbTableColumn from '@/components/table-column';
import { merge } from '@/util/common';
import { mapActions, mapGetters } from 'vuex';


export default {
  name: 'ChannelPopups',
  provide: function () {
    return {
      channelPopupsVM: this
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appId: String,
    isRabbittactics: {
      type: Boolean,
      default: false
    },
    /** 表格是否是多选 */
    multiple: {
      type: Boolean,
      default: true
    },
    /** 需要收端还是发端的数据 */
    terminalType: {
      /** 1:发送端,2:接收端 */
      default: ''
    },
    /**
     * 按 vipType 过滤渠道列表（前端客户端过滤）
     * 不传或空数组：不过滤
     * 传值：只保留 vipType 在该数组中的渠道
     * vipType 取值：0=公版SDK 1=公版APP 2=定制SDK 3=定制APP
     */
    vipTypeFilter: {
      type: Array,
      default: () => []
    },
    /** Dialog 自身是否插入至 body 元素上 */
    isAppendToBody: {
      type: Boolean,
      default: true
    },
    /** 遮罩层是否插入至 body 元素上 */
    modelIsAppendToBody: {
      type: Boolean,
      default: true
    },
    // 自己定义接口
    UrlConfig: {
      default: ''
    },
  },
  components: {
    LbTable,
    LbTableColumn,
    lazyTable
  },
  computed: {
    selectedNum () {
      return this.selectedChannels.length || 0
    },
    ...mapGetters('runActivityManage', [
      'platformTypes',
      'deviceTypes'
    ]),
    // selectedChannels() {
    //   return this.list.filter(item => (item.checked))
    // }
  },
  data () {
    return {
      visibleLazyTable:false,
      listLoading: false,
      checked: false,
      listBackStore: [],
      listSelected: [], // 已经选中数据
      listIds: [], // 选中的数据ID
      list: [],
      selectedIds: [],
      selectedNames: [],
      form: {
        name: '',
        terminalType: '',
        platformType: '',
        vipType: ''
      },
      showPreview: false,
      firstLoad: false, // 第一次打开
      total: 0,
      pageSize: 20,
      selectedAll: false,
      indeterminate: false,
      formSize: 'small',
      platformOptions: [{
        id: 1,
        name: 'Android'
      }, {
        id: 2,
        name: 'IOS  '
      }, {
        id: 3,
        name: 'PC'
      }, {
        id: 4,
        name: 'MAC'
      }],
      terminalOptions: [{
        id: 1,
        name: '发送端'
      }, {
        id: 2,
        name: '接收端'
      }],
      channelListLoading: false,
      selectedChannels: [],
      currentPage: 1,
      tableData: [],
      channelQuery: {
        name: '',
        businessType: '',
        platformType: '',
        /** 传入的props */
        terminalType: this.terminalType ? this.terminalType : '',
      }
    }
  },
  methods: {
    ...mapActions('runActivityManage', [
      'getDicts'
    ]),
    handleSizeChange (size) {
      // const pre = this.currentPage;
      this.pageSize = size;
      this.currentPage = 1;
      this.getList();
    },
    // 分页变化
    handleCurrentChange (page) {
      this.currentPage = page;
      this.getList();
    },
    // 查询
    handleSearch () {
      this.currentPage = 1;
      this.getList();
    },
    // 强制刷新
    forceUpdate() {
      const forceRefresh = 1
      /** 强制刷新时 分页查询多传一个forceRefresh参数 */
      this.getList(forceRefresh);
    },
    getList(forceRefresh) {
      const query = merge({}, this.channelQuery, {
        limit: 99999, // 不做分页
        page: 1,
        /** 获取是来自收端 2 还是发端 1  不传 默认不区分*/
        terminalType: this.terminalType ? this.terminalType : '',
      });
      /** 点击强制刷新时分页才传递forceRefresh=1 否则不传 */
      if (forceRefresh) {
        query.forceRefresh = forceRefresh;
      }
      this.channelListLoading = true;
      let getList;
      // 如果是策略管理用这个接口请求数据
      if (this.isRabbittactics) {
        getList = getChannelsResource;
      } else {
        getList = getChannels;
      }
      //判断是否需要自定义接口
      if (this.UrlConfig) {
        getList = this.UrlConfig;
      }
      this.list = []
      return getList(query)
        .then(({ data: res }) => {
          if (res.code === 200) {
            // this.list = res.data.list;
            // this.total = res.data;
            const filtered = this.filterByVipType(res.data);
            this.list = this.formatData(filtered);
            // 首次或 vipTypeFilter 变化导致数量不一致时刷新缓存，保证 isAll 判定准确
            if (this.listBackStore.length < 1 || this.listBackStore.length !== this.list.length) {
              this.listBackStore = this.list.slice(0)
            }
            // this.selectedChannels = this.patchSelectItems(this.selectedChannels, this.list)
            this.initCheckboxGroup()
          }
        })
        .finally(() => {
          this.channelListLoading = false;
        })
    },
    handleSelectAll: function (checked) {
      this.indeterminate = false;
      this.checked = checked
      this.list.forEach(item => item.checked = checked);
      this.selectedChannels = this.patchSelectItems(this.selectedChannels, this.list.map(item => item))
      this.listIds = this.selectedChannels.map(item => (item.id));
    },
    /** 单选选中的方法 */
    handleSingleSelectChange (row, selected) {
      console.log(row, selected);
      let res = []
      // 遍历列表，确保只有当前选中的行被标记为选中
      this.list.forEach(function (item) {
        if (item.id === row.id) {
          item.checked = undefined;
          res = [{ ...item }]
        } else {
          item.checked = false;
        }
      });
      console.log('res', res);
      this.selectedChannels = res
      this.listIds = res.map(item => (String(item.id)));
      console.log('this.selectedChannels', this.selectedChannels);
      console.log('this.listIds', this.listIds);
    },
    handleSelectChange (row, selected) {
      this.list.forEach(function (item) {
        if (item.id === row.id) {
          item.checked = selected;
        }
      });
      let list = this.list.filter(function (item) {
        return item.checked;
      });
      console.log('list', this.list);
      console.log('selectedChannels', this.selectedChannels);
      const checkedCount = list.length;
      this.checked = checkedCount === this.list.length;
      this.indeterminate = checkedCount > 0 ? checkedCount < this.list.length : false;
      this.selectedChannels = this.patchSelectItems(this.selectedChannels, this.list.map(item => item))
      this.listIds = this.selectedChannels.map(item => (item.id));
      console.log('return的selectedChannels', this.selectedChannels);
      console.log('return的listIds', this.listIds);
    },
    // patchSelectItems (oldItems, newItems) {
    //   console.log('旧数据', oldItems);
    //   console.log('新数据', newItems);

    //   // 如果旧数据为空，返回新数据中被选中的项
    //   if (oldItems.length === 0) {
    //     return newItems.filter(item => item.checked);
    //   }

    //   // 如果新数据为空，直接返回旧数据
    //   if (newItems.length === 0) {
    //     return oldItems;
    //   }

    // // 新旧数据均不为空时的处理逻辑
    // const newSelectedItems = newItems.filter(item => item.checked);
    // const newSelectedIds = new Set(newSelectedItems.map(item => item.id));
    // const oldIds = new Set(oldItems.map(item => item.id));

    // // 过滤旧数据中不再选中的项，并添加新数据中新增的选中项
    // const updatedOldItems = oldItems.filter(item => newSelectedIds.has(item.id));
    // const addedNewItems = newSelectedItems.filter(item => !oldIds.has(item.id));
    //   return updatedOldItems.concat(addedNewItems);
    // },
    patchSelectItems (oldItems, newItems) {
      console.log('旧数据', oldItems);
      console.log('新数据', newItems);
      // 旧数据为空
      if (oldItems.length < 1) {
        return newItems.filter(function (item) { return item.checked })
      }
      if (newItems.length < 1) {
        return oldItems.map(function (item) { return item })
      }
      // 新旧都有数据
      var items = []
      if (oldItems.length > 0 && newItems.length > 0) {
        const oldIds = oldItems.map(function (item) { return item.id })
        const newIds = newItems.map(function (item) { return item.id })
        const newSelectItems = newItems.filter(function (item) { return item.checked })
        const newSelectIds = newSelectItems.map(function (item) { return item.id })

        for (var i = 0; i < newSelectIds.length; i++) {
          //  旧数据中不存在就新增加
          if (oldIds.indexOf(newSelectIds[i]) === -1) {
            items.push(newSelectItems[i]);
          }
        }
        oldItems = oldItems.filter(function (item) {
          if (newIds.indexOf(item.id) !== -1 && newSelectIds.indexOf(item.id) === -1) {
            return false
          }
          return true
        })
      }
      return items.concat(oldItems)
    },
    // 删除选择的渠道数据
    handleDelSelection (row) {
      console.log('this.selectedChannels', this.selectedChannels)
      this.selectedChannels.splice(this.selectedChannels.findIndex(item => item.id === row.id), 1)
      console.log('删除', this.selectedChannels)
      for (let item of this.list) {
        if (item.id === row.id) {
          item.checked = false
        }
      }
      this.handleSelectChange(row, false)
    },
    // 清除选择的所有渠道
    handleClear () {
      this.selectedChannels = []
      this.list.forEach(item => (item.checked = false))
      this.handleSelectAll(false)
    },
    // 打开弹窗
    handleOpen: function () {
      this.$nextTick(() => {
        this.initIds()
        // 还没加载数据
        this.getList();
      })
    },
    initIds: function () {
      var has = {}
      this.listIds = []
      var list = (typeof this.appId === 'string') ? this.appId.split(',').map(id => (+id)) : ''
      for (var i = 0; i < list.length; i++) {
        var id = list[i]
        if (!has[id]) {
          has[id] = true
          this.listIds.push(id)
        }
      }
      this.hasIds = has
    },
    initCheckboxGroup () {
      this.selectedChannels = this.patchSelectItems(this.selectedChannels, this.list);
      var checkedCount = this.selectedChannels.slice(0).length
      this.checked = checkedCount === this.list.length;
      this.indeterminate = checkedCount > 0 ? checkedCount < this.list.length : false;
      this.visibleLazyTable = false;
      setTimeout(() => {
        this.visibleLazyTable = true;
      }, 100);
    },
    /**
     * 按 vipType 过滤渠道列表
     * vipTypeFilter 为空数组：不过滤
     * 否则只保留 vipType 在 vipTypeFilter 中的渠道
     */
    filterByVipType (list) {
      if (!Array.isArray(this.vipTypeFilter) || this.vipTypeFilter.length === 0) {
        return list;
      }
      return list.filter(item => this.vipTypeFilter.indexOf(item.vipType) > -1);
    },
    formatData (list) {
      const ids = this.listIds;
      console.log('this.ids', this.listIds)
      list.forEach((item) => {
        item.platformTypeName = this.formatPlatformType(item);
        item.terminalTypeName = this.formatDeviceType(item);
        // item.vipTypeName = this.formatVipType(item.vipType);
        if (ids.indexOf(item.id) > -1) {
          item.checked = this.multiple ? true : undefined
        } else {
          item.checked = false
        }
      })
      return list;
    },
    handleCancel () {
      this.handleClose();
    },
    formatDeviceType ({ businessType }) {
      if (!businessType) return '';
      for (let item of this.deviceTypes) {
        if (item.dictKey == businessType) {
          return item.dictValue;
        }
      }
    },
    formatPlatformType ({ platformType }) {
      if (!platformType) return '';
      for (let item of this.platformTypes) {
        if (item.dictKey == platformType) {
          return item.dictValue;
        }
      }
    },
    // 格式
    formatTerminalType ({ terminalType }) {
      for (let item of this.terminalOptions) {
        if (item.id === terminalType) {
          return item.name;
        }
      }
    },
    // 把选择的数据抛出给表单 appidStr, channel
    handleSave () {
      let channelNames = [];
      let channelIds = [];
      let nameStr = []
      let terminalType = []
      // this.listSelected = this.patchSelectItems(this.listSelected, this.selectedChannels)
      const list = this.selectedChannels.map(function (item) {
        item.checked = true
        return item;
      });
      for (let i = 0, l = list.length; i < l; i++) {
        channelNames.push(`[${list[i].id}]${list[i].name}`);
        nameStr.push(list[i].name);
        channelIds.push(list[i].id);
        terminalType.push(list[i].terminalType)
      }
      this.$emit('comfirm', {
        isAll: list.length >= this.listBackStore.length,
        channel: channelNames.join(';'),
        appId: channelIds.join(','),
        nameStr: nameStr.join(','),
        terminalType: terminalType.join(',')
      });
      /** 也要清除this.appId */
      this.appId = '';
      this.handleClose();
    },
    handleClose () {
      this.checked = false;
      this.indeterminate = false;
      this.selectedChannels = [];
      this.list = [];
      this.clearForm();
      this.handleClear();
      this.$emit('close');
      this.$emit('update:visible');
    },
    // 清空表单
    clearForm () {
      for (let key of Object.keys(this.channelQuery)) {
        this.channelQuery[key] = ''
      }
    }
  },
  created () {
    this.hasIds = {}
    this.getDicts('PLATFORM_TYPES');
    this.getDicts('DEVICE_TYPES');
  }
}
</script>

<style lang="scss">
$border-color: #ebeef5;

.channel-dialog__wrap {
  .channel-list-item {
    border: 1px solid $border-color;
    border-bottom: none;

    &:last-of-type {
      border-bottom: 1px solid $border-color;
    }

    .table-cell {
      height: 20px;
      padding: 8px 0;
      text-align: center;
    }

    .el-col {
      margin-bottom: 0;
    }

    .el-col + .el-col {
      border-left: 1px solid $border-color;
    }
  }

  .channel-list-item + .channel-list-item {
    border-left: 1px solid $border-color;
  }

  .list-table__header {
    padding-right: 7px;

    & .el-row {
      border: 1px solid $border-color;
    }

    .table-cell {
      height: 20px;
      padding: 8px 0;
      text-align: center;
    }

    .el-col + .el-col {
      border-left: 1px solid $border-color;
    }

    .el-col {
      margin-bottom: 0;
    }
  }

  .list-table__body {
    border-bottom: 1px solid $border-color;
  }
}
</style>
